import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeedbackApiBase } from './feedback-api-base';
import { ConnectGoogleRequest, DataEnvelope, GoogleConnection } from '../models';

/**
 * Mirrors App\Http\Controllers\GoogleConnectionController — a Brafton user's Google
 * account link for the Google exports. The browser only ever handles the one-time
 * authorization code; the refresh token stays server-side.
 */
@Injectable({ providedIn: 'root' })
export class GoogleConnectionService extends FeedbackApiBase {
  /** GET /v1/google/connection — whether the user has connected Google. */
  getConnection(email: string): Observable<GoogleConnection> {
    return this.http
      .get<DataEnvelope<GoogleConnection>>(this.url('google/connection'), {
        params: this.buildParams({ email }),
      })
      .pipe(map((response) => response.data));
  }

  /**
   * POST /v1/google/connection — exchanges the consent popup's one-time code and
   * stores the user's Google grant. Fails with 422 `{ message, reason }` when the
   * Google account doesn't match `email` or access wasn't fully granted.
   */
  connect(request: ConnectGoogleRequest): Observable<GoogleConnection> {
    return this.http
      .post<DataEnvelope<GoogleConnection>>(this.url('google/connection'), request)
      .pipe(map((response) => response.data));
  }

  /** DELETE /v1/google/connection — revokes and forgets the user's Google grant. */
  disconnect(email: string): Observable<void> {
    return this.http.delete<void>(this.url('google/connection'), {
      params: this.buildParams({ email }),
    });
  }
}
